<div class="container">

<h1>DATOS DEL SOLICITANTE</h1>

<form class="form-grid" [formGroup]="form" (ngSubmit)="enviar()">

<!-- DATOS SOLICITANTE -->

<div class="card">

<div class="grid-2">

<div class="column">

<div class="form-group">
<label>Nombres</label>
<input type="text" formControlName="nombres">
</div>

<div class="form-group">
<label>Apellidos</label>
<input type="text" formControlName="apellidos">
</div>

<div class="form-group">
<label>RUT</label>
<input type="text" formControlName="rut">
</div>

</div>

<div class="column">

<div class="form-group">
<label>Teléfono</label>
<input type="text" formControlName="telefono">
</div>

<div class="form-group">
<label>Correo electrónico</label>
<input type="email" formControlName="correo">
</div>

<div class="form-group">
<label>Dirección - Nro.</label>
<input type="text" formControlName="direccion">
</div>

<div class="row">

<div class="form-group">
<label>Comuna</label>
<input type="text" formControlName="comuna">
</div>

<div class="form-group">
<label>Región</label>
<input type="text" formControlName="region">
</div>

</div>

</div>

</div>

</div>

<!-- PROVEEDORES -->

<div class="grid-2 cards">

<div class="card">

<h2>Datos del Proveedor Inicial</h2>

<div class="form-group">
<label>Nombre Proveedor</label>
<input type="text" formControlName="proveedor">
</div>

<div class="form-group">
<label>Rut Proveedor</label>
<input type="text" formControlName="rutproveedor">
</div>

</div>


<div class="card">

<h2>Datos del Nuevo Receptor</h2>

<div class="form-group">
<label>Nombre Proveedor</label>
<input type="text" formControlName="nombreproveedorreceptor">
</div>

<div class="form-group">
<label>Rut Proveedor</label>
<input type="text" formControlName="rutproveedorreceptor">
</div>

</div>

</div>


<!-- PRODUCTOS -->

<div class="grid-2 cards">

<!-- PRODUCTOS VIGENTES -->

<div class="card">

<h2>Productos Vigentes</h2>

<table formArrayName="productosVigentes">

<tr>
<th>Producto</th>
<th>Monto</th>
<th></th>
</tr>

<tr *ngFor="let item of productosVigentes.controls; let i = index" [formGroupName]="i">

<td>
<input formControlName="producto">
</td>

<td>
<input formControlName="monto">
</td>

<td>
<button type="button" id="eliminarproducto" (click)="eliminarProductoVigente(i)">X</button>
</td>

</tr>

</table>

<button type="button" (click)="agregarProductoVigente()">
Agregar producto
</button>

</div>


<!-- PRODUCTOS A CONTRATAR -->

<div class="card">

<h2>Productos que quiere contratar</h2>

<ul class="products" formArrayName="productosContratar">

<li *ngFor="let item of productosContratar.controls; let i = index">

<input [formControlName]="i">

<button type="button" (click)="eliminarProductoContratar(i)">
X
</button>

</li>

</ul>

<button type="button" (click)="agregarProductoContratar()">
Agregar producto
</button>

</div>

</div>


<!-- SUBMIT -->

<div class="form-actions">
<button type="submit">Enviar Solicitud</button>
</div>

@if (mostrarMensaje) {
  <div class="error-banner">
    ⚠️ Por favor complete todos los campos requeridos
  </div>
}

</form>

</div>


<ng-template #modalCustom let-modal>
  <div #modalContainer>
    <div class="custom-modal">
      <div class="custom-modal-header">
        Solicitud de Portabilidad Financiera
      </div>
      <div class="custom-modal-body">
        <p>Su solicitud fue enviada</p>
      </div>
      <div class="custom-modal-footer">
        <button type="button" class="btn btn-rounded" (click)="modal.dismiss('Cross click')">OK</button>
      </div>
    </div>
  </div>
</ng-template>